<template>
  <div class="dragonHome">
    <div class="dragonNav">
      <!-- <div class="logo"></div> -->
      <div class="navDiv myBar">
        <router-link class="nav" :class="{'navActive': activeIndex==0}" to="/dragon_star/index">首页</router-link>
        <router-link class="nav" :class="{'navActive': activeIndex==1}" to="/dragon_star/about">关于龙腾之星</router-link>
        <router-link class="nav" :class="{'navActive': activeIndex==2}" to="/dragon_star/guide">参赛指南</router-link>
        <router-link class="nav" :class="{'navActive': activeIndex==3}" to="/dragon_star/award_setting">奖项设置</router-link>
        <router-link class="nav" :class="{'navActive': activeIndex==4}" to="/dragon_star/sign_up?isShow=1">我要报名</router-link>
        <!-- <router-link class="nav" :class="{'navActive': activeIndex==5}" to="/dragon_star/award_exhibition">获奖展示</router-link>
        <router-link class="nav" :class="{'navActive': activeIndex==6}" to="/dragon_star/review">历史回顾</router-link> -->
        <router-link class="nav" :class="{'navActive': activeIndex==7}" to="/dragon_star/activities">相关资讯</router-link>
        <!-- <router-link class="nav" :class="{'navActive': activeIndex==8}" to="/dragon_star/contact_us">联系我们</router-link>   -->
        <router-link class="nav" :class="{'navActive': activeIndex==9}" to="/dragon_star/exemption">免责须知</router-link>  
      </div>
      <div class="signUp">
        <Button v-if="!gIsLogin()" class="signUpBtn" shape="circle" @click="toSignUp">我要报名</Button>
        <template v-else>
          <Dropdown>
            <div class="loginWrap">
              <img v-if="userInfo.avatar" class="userAvatar" :src="getImageUrl(userInfo.avatar, 'avatar')" alt="">
              <span class="userName">{{userInfo.trueName}}</span>
            </div>
            <DropdownMenu slot="list">
              <DropdownItem><router-link class="downItemColor" to="/personal_info" target="_blank">完善信息</router-link></DropdownItem>
              <DropdownItem><span @click="logOut">退出登录</span></DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </div>
    </div>
    <div class="center" style="padding:10px; display:none;">温馨提示：应参赛学生申请，经大赛组委会研究决定，提交平台开放延期至10月20日24点</div>
    <router-view></router-view>
    <!-- 联系我们 -->
    <div class="contactWrap">
      <Row type="flex" align="middle" justify="center" :gutter="30">
        <Col :lg="{span: 5}" :sm="{span:24}" class="center">
          <img class="footerLogo" src="/img/dragonStar/logo.png" alt="">
        </Col>
        <Col :lg="{span: 12}" :sm="{span:24}">
          <Row :gutter="50" class="bdLR">
            <Col :lg="12" :sm="24">
              <p class="footerTitle">联系组委会</p>
              <p><span class="footerLabel">电话</span>010-83681553</p>
              <p><span class="footerLabel">手机</span>15810007797</p>
              <p><span class="footerLabel">邮箱</span>601@ddfddf.org</p>
              <p><span class="footerLabel">地址</span>北京市大兴区金苑路26号3号楼</p>
              <p><span class="footerLabel">邮编</span>102628</p>
            </Col>
            <Col :lg="12" :sm="24">
              <p class="footerTitle mobilePdtop">商务合作</p>
              <p><span class="footerLabel">电话</span>010-83681552</p>
              <p><span class="footerLabel">手机</span>15810007797</p>
              <p><span class="footerLabel">邮箱</span>601@ddfddf.org</p>
              <p><span class="footerLabel">地址</span>北京市大兴区金苑路26号3号楼</p>
              <p><span class="footerLabel">邮编</span>102628</p>
            </Col>
          </Row>
        </Col>
        <Col :lg="{span: 7}" :sm="{span:24}" class="center">
          <img class="footerImg" src="/img/dragonStar/wxcode.jpg" alt="">
          <img class="footerImg" src="/img/dragonStar/wxcode_ly.jpg" alt="">
        </Col>
      </Row>
    </div>
    <!-- copyright -->
    <div class="copyright center">
      Copyright @ 2020龙腾之星全球大学生绿色设计大赛组委会 保留一切权利<br class="lgHidden" /><span class="smHidden"> ｜ </span>京ICP备13011399号-4<span class="smHidden" style="display:none"> | 京公网安备 12345678909876号</span>
    </div>
    <BackTop><div class="backTop"></div></BackTop>

    <!-- 报名须知 -->
    <Modal v-model="isShow"
      title="龙腾之星报名须知"
      :mask-closable="false"
      :footer-hide="true"
      class-name="notesModal"
      width="80">
      <SignUpNotes />
    </Modal>
  </div>
</template>

<script>
import SignUpNotes from "@/components/dragonStar/SignUpNotes.vue";
export default {
  components: {
    SignUpNotes
  },
  data() {
    return {
      isShow: false,
      userInfo: {}
    };
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo;
    document.title = "龙腾之星全球大学生绿色设计大赛";
  },
  computed: {
    activeIndex() {
      let name = this.$route.name;
      if (name == "StarIndex") {
        return 0;
      }
      if (name == "StarAbout") {
        return 1;
      }
      if (name == "StarGuide") {
        return 2;
      }
      if (name == "StarAwardSetting") {
        return 3;
      }
      if (name == "StarSignUp") {
        return 4;
      }
      if (name == "StarAwardExhibition") {
        return 5;
      }
      if (name == "StarReview") {
        return 6;
      }
      if (name == "StarActivities") {
        return 7;
      }
      if (name == "StarContactUs") {
        return 8;
      }
      if (name == "StarExemption") {
        return 9;
      }
      return 0;
    }
  },
  methods: {
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.push("/dragon_star/index");
    },
    // 去报名
    toSignUp() {
      this.isShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.dragonHome {
  padding-top: 100px;

  .dragonNav {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 100px;
    line-height: 100px;
    padding: 0 150px;
    text-align: center;
    z-index: 1000;
    background: #ffffff;

    .logo {
      position: absolute;
      left: 50px;
      top: 0;
      width: 85px;
      height: 100px;
      background: url(/img/dragonStar/logo.png) no-repeat left center;
      background-size: contain;
    }
    .navDiv {
      overflow: auto;
      white-space: nowrap;

      .nav {
        display: inline-block;
        margin: 0 25px;
        color: #404040;
        position: relative;
      }
      .navActive::after {
        content: "";
        position: absolute;
        bottom: 30px;
        left: 50%;
        width: 30px;
        height: 0;
        margin-left: -15px;
        border-top: 2px solid #404040;
      }
    }

    .navDiv::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 2px;
    }
    .navDiv::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #777777;
    }
    .navDiv::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #eeeeee;
    }

    .signUp {
      position: absolute;
      right: 50px;
      top: 0;
      max-width: 85px;

      .loginWrap {
        line-height: 1.8em;
        margin-top: 35px;
        cursor: pointer;

        &::after {
          position: absolute;
          right: -10px;
          top: 4px;
          content: "\f33d";
          font-family: Ionicons;
        }
      }

      .userAvatar {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        vertical-align: middle;
        margin-right: 5px;
      }
      .userName {
        display: inline-block;
        width: 50px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
      .downItemColor {
        color: #515a6e;
      }
    }
  }
  .contactWrap {
    padding: 0 50px 50px;
    line-height: 1.8em;

    .footerImg {
      width: 50%;
      min-width: 100px;
      padding: 30px;
    }
    .footerLogo {
      width: 125px;
      max-width: 100%;
      margin: 30px 0;
    }
    .footerTitle {
      font-weight: 600;
      color: #4c4c4c;
      padding-bottom: 5px;
    }
    .footerLabel {
      display: inline-block;
      padding-right: 15px;
    }
    .bdLR {
      border-left: 1px solid #8c8c8c;
      border-right: 1px solid #8c8c8c;
    }
  }
  .copyright {
    padding: 10px 0;
    background: #e6e6e6;
    color: #707070;
    line-height: 1.8em;
  }
  .lgHidden {
    display: none;
  }
}
@media (max-width: 992px) {
  .dragonHome {
    .dragonNav {
      padding: 0 110px;

      .navDiv .nav {
        margin: 0 10px;
      }

      .logo {
        left: 15px;
      }
      .signUp {
        right: 15px;
      }
    }
    .contactWrap {
      .footerImg {
        width: 30%;
        min-width: 150px;
      }
      .mobilePdtop {
        padding-top: 30px;
      }
      .bdLR {
        border: none;
        padding: 30px 0;
      }
    }
    .lgHidden {
      display: block;
    }
    .smHidden {
      display: none;
    }
  }
}
</style>